export const SITE_URL = "https://www.mezcaldonhesiquio.com";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;
export const SITE_NAME = "Mezcal Don Hesiquio";

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  description:
    "Mezcal artesanal de Santiago Tilantongo, Oaxaca. Espadín, Tobalá y Madrecuishe elaborados con tradición mixteca.",
  sameAs: [
    "https://www.facebook.com/profile.php?id=100087593805690",
    "https://www.instagram.com/mezcaldonhesiquio/",
  ],
};

const defaultPublic = {
  title: `${SITE_NAME} | Mezcal artesanal de Oaxaca`,
  description:
    "Mezcal artesanal Don Hesiquio, elaborado en Santiago Tilantongo, Oaxaca. Compra Espadín, Tobalá y más en línea.",
};

const privateSeo = {
  title: `${SITE_NAME}`,
  description: defaultPublic.description,
  noindex: true,
};

export const seoByPath = {
  "/": {
    title: "Mezcal artesanal Don Hesiquio | Santiago Tilantongo, Oaxaca",
    description:
      "Mezcal artesanal Don Hesiquio, nacido en Santiago Tilantongo, Oaxaca. Tradición mixteca, agave propio y destilación en alambique de cobre.",
    jsonLd: organizationJsonLd,
  },
  "/Mezcales": {
    title: "Nuestros mezcales | Mezcal Don Hesiquio",
    description:
      "Conoce los mezcales Don Hesiquio: Espadín, Tobalá y Madrecuishe. Mezcal artesanal joven de la Mixteca oaxaqueña.",
  },
  "/mezcal-espadin": {
    title: "Mezcal Espadín 750 ml | Don Hesiquio",
    description:
      "Mezcal Espadín Don Hesiquio, 100% Agave angustifolia, 750 ml. Notas de agave cocido, cítricos y ahumado sutil. Compra en línea.",
  },
  "/mezcal-tobala": {
    title: "Mezcal Tobalá 750 ml | Don Hesiquio",
    description:
      "Mezcal Tobalá Don Hesiquio, 100% Agave potatorum, 750 ml. Notas de frutos maduros, mieles y ahumados sutiles. Compra en línea.",
  },
  "/ListaProductos": {
    title: "Tienda de mezcal artesanal | Don Hesiquio",
    description:
      "Compra mezcal Don Hesiquio y productos de la marca. Envío a todo México.",
  },
  "/Elaboracion": {
    title: "Elaboración del mezcal | Don Hesiquio",
    description:
      "Así se elabora Mezcal Don Hesiquio: cultivo de agave, horno de piedra, molino, fermentación y destilación en alambique de cobre.",
  },
  "/Contacto": {
    title: "Contacto | Mezcal Don Hesiquio",
    description:
      "Contacta a Mezcal Don Hesiquio para pedidos, eventos y atención a clientes.",
  },
  "/cocteles": {
    title: "Cócteles con mezcal | Don Hesiquio",
    description:
      "Recetas de cócteles con Mezcal Don Hesiquio: Mezc-old Fashioned, Mezcal Especial y Fresco Mezcal.",
  },
  "/maridajes": {
    title: "Maridajes de mezcal | Don Hesiquio",
    description:
      "Maridajes para disfrutar Mezcal Don Hesiquio: platillos, momentos y recomendaciones de servicio.",
  },
  "/cocteles-y-maridajes": {
    title: "Cócteles y maridajes | Don Hesiquio",
    description:
      "Ideas de cócteles y maridajes para Mezcal Don Hesiquio Espadín y Tobalá.",
  },
  "/Eventos": {
    title: "Eventos | Mezcal Don Hesiquio",
    description:
      "Próximos eventos de Mezcal Don Hesiquio. Experiencias alrededor del mezcal artesanal oaxaqueño.",
  },
  "/Terminos": {
    title: "Términos y condiciones | Mezcal Don Hesiquio",
    description:
      "Términos y condiciones de uso del sitio Mezcal Don Hesiquio.",
  },
};

const cocktailSeo = {
  [`/cocteles/Mezc-old-Fashioned`]: {
    title: "Mezc-old Fashioned | Cócteles Don Hesiquio",
    description:
      "Receta del cóctel Mezc-old Fashioned con Mezcal Don Hesiquio.",
  },
  [`/cocteles/Mezcal-Especial`]: {
    title: "Mezcal Especial | Cócteles Don Hesiquio",
    description:
      "Receta del cóctel Mezcal Especial con Mezcal Don Hesiquio.",
  },
  [`/cocteles/Fresco-Mezcal`]: {
    title: "Fresco Mezcal | Cócteles Don Hesiquio",
    description:
      "Receta del cóctel Fresco Mezcal con Mezcal Don Hesiquio.",
  },
};

const privatePrefixes = [
  "/Login",
  "/SignUp",
  "/ConfirmarCodigo",
  "/pago",
  "/Carrito",
  "/datos-envio",
  "/datos-envio-card",
  "/envio",
  "/CompraExitosa",
  "/Comprar",
  "/SidebarUsuario",
  "/edicionNombre",
  "/edicionCorreo",
  "/reset-password",
  "/reset-password-email",
  "/new-password",
  "/edicionTelefono",
  "/datosPersonales",
  "/correoEnviado",
  "/pantalla-exito",
  "/edicionPassword",
  "/edicionCorreoUser",
  "/edicion-correo-success",
  "/codigo-telefono",
  "/datos-personales",
  "/sumar-puntos",
  "/registrar-puntos",
  "/registrar-puntos-success",
];

export function getSeoForPath(pathname) {
  if (seoByPath[pathname]) {
    return { ...seoByPath[pathname], path: pathname };
  }
  if (cocktailSeo[pathname]) {
    return { ...cocktailSeo[pathname], path: pathname };
  }
  if (pathname.startsWith("/cocteles/")) {
    return { ...seoByPath["/cocteles"], path: pathname };
  }
  if (privatePrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
    return { ...privateSeo, path: pathname };
  }
  return { ...defaultPublic, path: pathname || "/" };
}
